import Fuse from 'fuse.js';

export const searchAndFilter = (
  items: Json[],
  keys: string[],
  q: string,
  tag: string,
  threshold = 0.3
) => {
  let results = [...items];

  if (q) {
    const fuse = new Fuse(results, {
      includeScore: true,
      shouldSort: true,
      threshold,
      keys,
    });

    results = fuse.search(q).map((fuseResult) => fuseResult.item);
  }
  if (tag !== 'all') {
    results = results.filter((t) => t.tags.includes(tag));
  }

  return results;
};
